// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-05-12T12:10:39+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  192125
//    Project:        617
//    Environment:    7626 - master
//    MD5:            61067ca66ad148c3f8f52f9ba11d77a4
//    Signature:      eyJpdiI6IjJmZVdNUEVxSHg5bEE3WEhTMmxqMUE9PSIsInZhbHVlIjoiVlVYUG5jbHRGWHc3andoNzVxSEJOeXR6MDlyY3pONFp1VHRLK0FhYWYyZ2NWMStCQ3poWVFJUHpxcEdlR2F5Y3NPSnQ2aE9cL216b1BWTmhBeUU1aytCbG9mSURzTjFVZkdCclNqN1ZVZFwvXC9XOFpPcVhEV3ZLSVZnSW1DbnU3ZzhyMXlLS2hDYXdIZklVSHE0d2N3Z255RjB2amNsNWkrblRoZDdVR3NkY0NNRjlpV3pheU1XQWNvVUpCQmdBV3JcLzZzcHFuRFFDR0pVV1pSR1wvYSsyMldqellUUmFQUWdBZXQ0TCt2cnNLRVRFVHp5T3BsdHExMVU1MTN2THZqalNaTXpWenozQTFwYmRqVGVBeGZ0dDRsSDl6SXlzVTdTSXdFenJ5UzBXSlB2ZERvQWUrV0NSZlFwaUh4QVhvTTZUWG4yWXhyWG5ONWJXT0JHNTBxZW9qVmEycVdzQVR6bjhROVVZWWVIWll2d0xHeXh5U3k3S1JzRGc3TGJFdGZ1SU83R2FNcXhRd3c5TGZGZnBreG13NmhnPT0iLCJtYWMiOiI1YzQ1MDA5ZGFiODIzMTlhMjA2ZTRjZjEzMTlhZDQyOTJmYzY4ZTlmODViYWNhMDFjZDhjMzM5MWI2MGFmZGFlIn0=
class upsellSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {}
}

class upsellItem extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.add = this.querySelector('.product-form__submit');
    this.submitButton = this.querySelector('[type="submit"]');
    this.data = JSON.parse(
      this.querySelector('[data-upsell-json]')?.innerHTML || '{}'
    );
  }
  connectedCallback() {
    this.addEventListeners();
  }
  addEventListeners() {
    if (this.select) {
      this.select.addEventListener('change', (e) => this.updateID());
    }
  }
  updateID() {
    const colorSelected = this.select.dataset.colorVariant.toLowerCase();
    const sizeSelected = this.select.value.toLowerCase();
    const variantId = this.data.variants.find(
      (variant) =>
        variant.color === colorSelected && variant.size === sizeSelected
    ).id;
    const inputVariant = this.querySelector('.variant-id');
    inputVariant.value = variantId;
    this.submitButton.click();
  }
}

class UpsellProductForm extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.form = this.querySelector('form');
    if (this.variantIdInput) {
      this.variantIdInput.disabled = false;
    }
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cart =
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer');
    this.submitButton = this.querySelector('[type="submit"]');
    this.submitButtonText = this.submitButton.querySelector('span');

    if (document.querySelector('cart-drawer'))
      this.submitButton.setAttribute('aria-haspopup', 'dialog');

    this.hideErrors = this.dataset.hideErrors === 'true';
  }
  onSubmitHandler(evt) {
    // ATC from another part of the code - causes conflicts if we don't include it within this option
    evt.preventDefault();
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    this.handleErrorMessage();

    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    this.querySelector('.loading__spinner').classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    if (this.cart) {
      formData.append(
        'sections',
        this.cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }
    config.body = formData;
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);

          const soldOutMessage =
            this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButtonText.classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: response,
          });
        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                this.cart.renderContents(response);
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty'))
          this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');
      });
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    this.errorMessageWrapper =
      this.errorMessageWrapper ||
      this.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage =
      this.errorMessage ||
      this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }

  toggleSubmitButton(disable = true, text) {
    if (disable) {
      this.submitButton.setAttribute('disabled', 'disabled');
      if (text) this.submitButtonText.textContent = text;
    } else {
      this.submitButton.removeAttribute('disabled');
      this.submitButtonText.textContent = window.variantStrings.addToCart;
    }
  }

  get variantIdInput() {
    return this.form?.querySelector('[name=id]');
  }
}
customElements.define('upsell-slider', upsellSlider);
customElements.define('upsell-item', upsellItem);
customElements.define('upsell-form', UpsellProductForm);
